unit View.Servicos.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UConstantes, System.StrUtils, UUtils, UPersonalizacao_Tabela,
  UPersonalizacao_Tabela.Interfaces, UHelperServer;

type
  TFViewServicosList = class(TForm)
    ServicosDataset: TXDataWebDataSet;
    ServicosDatasetid: TIntegerField;
    ServicosDatasetnome: TStringField;
    ServicosDatasetservico_preco: TFloatField;
    ServicosDatasettipo_servico_codigo: TStringField;
    ServicosDatasetservico_garantia: TIntegerField;
    ServicosDatasetcodigo_issqn: TStringField;
    ServicosDatasetcodigo_tributacao_municipio: TStringField;
    ServicosDatasetcodigo_interno: TIntegerField;
    ServicosDatasetexcluido: TBooleanField;
    ServicosDatasetinclusao: TDateTimeField;
    ServicosDatasetalteracao: TDateTimeField;
    ServicosDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    ServicosDatasetstatus_id: TIntegerField;
    btnExportarExcel: TButton;
    ServicosDatasetunidadesigla: TXDataWebDatasetField;
    ServicosDatasetserv_nacionalcTribNac: TStringField;
    ServicosDatasetserv_nacionaldescricao: TStringField;
    ServicosDatasetnbsnbs: TStringField;
    ServicosDatasetnbsdescricao: TStringField;
    procedure WebFormCreate(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure btnExportarExcelClick(Sender: TObject);
    procedure ServicosDatasetserv_nacionalcTribNacGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure ServicosDatasetnbsnbsGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewServicosList: TFViewServicosList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewServicosList }

procedure TFViewServicosList.btnExportarExcelClick(Sender: TObject);
begin
  TUtils.ExportarDadosExcel(ServicosDataset, WebDBTableControl1,
    FGridPlugin.FDatasetPlugin.FDataset.QueryString, FGridPlugin.FQuantidadeRegistrosBusca);
end;

procedure TFViewServicosList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewServicosList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewServicosList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewServicosList, AElementID, Result, @AfterCreate);
end;

procedure TFViewServicosList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
  begin
    FGridPlugin.SetFilterText(edSearch.Text, True);
  end;
end;

procedure TFViewServicosList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewServicosList.ServicosDatasetnbsnbsGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  if Sender.AsString.IsEmpty then
    Exit;

  Text := THelperServer.GetTextoMax100Caracteres(Sender.AsString + ' - ' +
    ServicosDataset.FieldByName('nbs.descricao').AsString);
end;

procedure TFViewServicosList.ServicosDatasetserv_nacionalcTribNacGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  if Sender.AsString.IsEmpty then
    Exit;

  Text := THelperServer.GetTextoMax100Caracteres(Sender.AsString + ' - ' +
    ServicosDataset.FieldByName('serv_nacional.descricao').AsString);
end;

procedure TFViewServicosList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewServicosList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ação' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      ServicosDataset.Connection.Model.DefaultSchema.FindEntityType(ServicosDataset.EntitySetName),
      ServicosDataset.CurrentData
    );

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-eye"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
    Button.ElementHandle.setAttribute('title', 'Ver dados');
    Button.ElementHandle.setAttribute('data-test', 'btn_ver_servico');
  end;
end;

procedure TFViewServicosList.WebDBTableControl1GetCellClass(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['nome', 'nbs.nbs',
      'serv_nacional.cTribNac', 'servico_preco']) of
      0, 1, 2: AClassName := 'text-start';
      3: AClassName := 'text-end';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewServicosList.WebDBTableControl1GetCellData(Sender: TObject;
  ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['excluido', 'status_id']) of
      0:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger"><i>'
      end;
      1:
      begin
        case StrToInt(AValue) of
          1 : AValue := '<div class="rounded-pill text-center" style="background-color: #198754;color:white; padding-right: 5px;padding-left: 5px;">Ativo</div>';
          2 : AValue := '<div class="rounded-pill text-center" style="background-color: #FF6347;color:white; padding-right: 5px;padding-left: 5px;">Inativo</div>';
        else AValue := '<div class="rounded-pill text-center" style="background-color: #1C1C1C;color:white; padding-right: 5px;padding-left: 5px;">Outros</div>';
        end;
      end;
      else
      begin
        if UpperCase(AValue) = 'NULL' then
          AValue := '';
      end;
    end;
  end;
end;

procedure TFViewServicosList.WebFormCreate(Sender: TObject);
begin
  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('servicos', 'active');
  TUtils.SetValorDicionarioClasses('cadastros_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_cadastros', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, ServicosDataset, lcPaginator,
    lbPaginationInfo);

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'nome';
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewServicosList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.servicos.list.pagination.info');
  WebDBTableControl1 := TDBTableControl.Create('view.servicos.list.table');
  cbPageSize := TComboBox.Create('view.servicos.list.cbPageSize');
  edSearch := TEdit.Create('view.servicos.list.search');
  lcPaginator := TListControl.Create('view.servicos.list.pagination');
  btnExportarExcel := TButton.Create('btnExportarExcel');
  ServicosDataset := TXDataWebDataSet.Create(Self);
  ServicosDatasetcodigo_interno := TIntegerField.Create(Self);
  ServicosDatasetnome := TStringField.Create(Self);
  ServicosDatasetunidadesigla := TXDataWebDatasetField.Create(Self);
  ServicosDatasetservico_preco := TFloatField.Create(Self);
  ServicosDatasetstatus_id := TIntegerField.Create(Self);
  ServicosDatasetservico_garantia := TIntegerField.Create(Self);
  ServicosDatasettipo_servico_codigo := TStringField.Create(Self);
  ServicosDatasetnbsnbs := TStringField.Create(Self);
  ServicosDatasetnbsdescricao := TStringField.Create(Self);
  ServicosDatasetserv_nacionalcTribNac := TStringField.Create(Self);
  ServicosDatasetserv_nacionaldescricao := TStringField.Create(Self);
  ServicosDatasetcodigo_issqn := TStringField.Create(Self);
  ServicosDatasetcodigo_tributacao_municipio := TStringField.Create(Self);
  ServicosDatasetexcluido := TBooleanField.Create(Self);
  ServicosDatasetinclusao := TDateTimeField.Create(Self);
  ServicosDatasetalteracao := TDateTimeField.Create(Self);
  ServicosDatasetexclusao := TDateTimeField.Create(Self);
  ServicosDatasetid := TIntegerField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  btnExportarExcel.BeforeLoadDFMValues;
  ServicosDataset.BeforeLoadDFMValues;
  ServicosDatasetcodigo_interno.BeforeLoadDFMValues;
  ServicosDatasetnome.BeforeLoadDFMValues;
  ServicosDatasetunidadesigla.BeforeLoadDFMValues;
  ServicosDatasetservico_preco.BeforeLoadDFMValues;
  ServicosDatasetstatus_id.BeforeLoadDFMValues;
  ServicosDatasetservico_garantia.BeforeLoadDFMValues;
  ServicosDatasettipo_servico_codigo.BeforeLoadDFMValues;
  ServicosDatasetnbsnbs.BeforeLoadDFMValues;
  ServicosDatasetnbsdescricao.BeforeLoadDFMValues;
  ServicosDatasetserv_nacionalcTribNac.BeforeLoadDFMValues;
  ServicosDatasetserv_nacionaldescricao.BeforeLoadDFMValues;
  ServicosDatasetcodigo_issqn.BeforeLoadDFMValues;
  ServicosDatasetcodigo_tributacao_municipio.BeforeLoadDFMValues;
  ServicosDatasetexcluido.BeforeLoadDFMValues;
  ServicosDatasetinclusao.BeforeLoadDFMValues;
  ServicosDatasetalteracao.BeforeLoadDFMValues;
  ServicosDatasetexclusao.BeforeLoadDFMValues;
  ServicosDatasetid.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewServicosList';
    Width := 555;
    Height := 424;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive grid-sticky-header';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'C'#243'd. Retaguarda';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'unidade.sigla';
      Title := 'Unidade';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'servico_preco';
      Title := 'Pre'#231'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'status_id';
      Title := 'Status';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'servico_garantia';
      Title := 'Garantia (Dias)';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'tipo_servico_codigo';
      Title := 'C'#243'd. Tipo Serv.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nbs.nbs';
      Title := 'Nbs';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'serv_nacional.cTribNac';
      Title := 'Serv. Nacional';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_issqn';
      Title := 'C'#243'd. issqn';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_tributacao_municipio';
      Title := 'C'#243'd. Trib. Munic.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    btnExportarExcel.SetParentComponent(Self);
    btnExportarExcel.Name := 'btnExportarExcel';
    btnExportarExcel.Left := 240;
    btnExportarExcel.Top := 63;
    btnExportarExcel.Width := 96;
    btnExportarExcel.Height := 25;
    btnExportarExcel.Caption := 'Exportar Excel';
    btnExportarExcel.ChildOrder := 11;
    btnExportarExcel.HeightPercent := 100.000000000000000000;
    btnExportarExcel.WidthPercent := 100.000000000000000000;
    SetEvent(btnExportarExcel, Self, 'OnClick', 'btnExportarExcelClick');
    ServicosDataset.SetParentComponent(Self);
    ServicosDataset.Name := 'ServicosDataset';
    ServicosDataset.EntitySetName := 'Servicos';
    ServicosDataset.Connection := DMConnection.ApiConnection;
    ServicosDataset.Left := 72;
    ServicosDataset.Top := 144;
    ServicosDatasetcodigo_interno.SetParentComponent(ServicosDataset);
    ServicosDatasetcodigo_interno.Name := 'ServicosDatasetcodigo_interno';
    ServicosDatasetcodigo_interno.FieldName := 'codigo_interno';
    ServicosDatasetcodigo_interno.Required := True;
    ServicosDatasetnome.SetParentComponent(ServicosDataset);
    ServicosDatasetnome.Name := 'ServicosDatasetnome';
    ServicosDatasetnome.FieldName := 'nome';
    ServicosDatasetnome.Required := True;
    ServicosDatasetnome.Size := 255;
    ServicosDatasetunidadesigla.SetParentComponent(ServicosDataset);
    ServicosDatasetunidadesigla.Name := 'ServicosDatasetunidadesigla';
    ServicosDatasetunidadesigla.FieldName := 'unidade.sigla';
    ServicosDatasetservico_preco.SetParentComponent(ServicosDataset);
    ServicosDatasetservico_preco.Name := 'ServicosDatasetservico_preco';
    ServicosDatasetservico_preco.FieldName := 'servico_preco';
    ServicosDatasetservico_preco.DisplayFormat := '#,##0.00';
    ServicosDatasetstatus_id.SetParentComponent(ServicosDataset);
    ServicosDatasetstatus_id.Name := 'ServicosDatasetstatus_id';
    ServicosDatasetstatus_id.FieldName := 'status_id';
    ServicosDatasetservico_garantia.SetParentComponent(ServicosDataset);
    ServicosDatasetservico_garantia.Name := 'ServicosDatasetservico_garantia';
    ServicosDatasetservico_garantia.FieldName := 'servico_garantia';
    ServicosDatasettipo_servico_codigo.SetParentComponent(ServicosDataset);
    ServicosDatasettipo_servico_codigo.Name := 'ServicosDatasettipo_servico_codigo';
    ServicosDatasettipo_servico_codigo.FieldName := 'tipo_servico_codigo';
    ServicosDatasettipo_servico_codigo.Size := 255;
    ServicosDatasetnbsnbs.SetParentComponent(ServicosDataset);
    ServicosDatasetnbsnbs.Name := 'ServicosDatasetnbsnbs';
    ServicosDatasetnbsnbs.FieldName := 'nbs.nbs';
    SetEvent(ServicosDatasetnbsnbs, Self, 'OnGetText', 'ServicosDatasetnbsnbsGetText');
    ServicosDatasetnbsdescricao.SetParentComponent(ServicosDataset);
    ServicosDatasetnbsdescricao.Name := 'ServicosDatasetnbsdescricao';
    ServicosDatasetnbsdescricao.FieldName := 'nbs.descricao';
    ServicosDatasetserv_nacionalcTribNac.SetParentComponent(ServicosDataset);
    ServicosDatasetserv_nacionalcTribNac.Name := 'ServicosDatasetserv_nacionalcTribNac';
    ServicosDatasetserv_nacionalcTribNac.FieldName := 'serv_nacional.cTribNac';
    SetEvent(ServicosDatasetserv_nacionalcTribNac, Self, 'OnGetText', 'ServicosDatasetserv_nacionalcTribNacGetText');
    ServicosDatasetserv_nacionaldescricao.SetParentComponent(ServicosDataset);
    ServicosDatasetserv_nacionaldescricao.Name := 'ServicosDatasetserv_nacionaldescricao';
    ServicosDatasetserv_nacionaldescricao.FieldName := 'serv_nacional.descricao';
    ServicosDatasetcodigo_issqn.SetParentComponent(ServicosDataset);
    ServicosDatasetcodigo_issqn.Name := 'ServicosDatasetcodigo_issqn';
    ServicosDatasetcodigo_issqn.FieldName := 'codigo_issqn';
    ServicosDatasetcodigo_issqn.Size := 255;
    ServicosDatasetcodigo_tributacao_municipio.SetParentComponent(ServicosDataset);
    ServicosDatasetcodigo_tributacao_municipio.Name := 'ServicosDatasetcodigo_tributacao_municipio';
    ServicosDatasetcodigo_tributacao_municipio.FieldName := 'codigo_tributacao_municipio';
    ServicosDatasetcodigo_tributacao_municipio.Size := 255;
    ServicosDatasetexcluido.SetParentComponent(ServicosDataset);
    ServicosDatasetexcluido.Name := 'ServicosDatasetexcluido';
    ServicosDatasetexcluido.FieldName := 'excluido';
    ServicosDatasetinclusao.SetParentComponent(ServicosDataset);
    ServicosDatasetinclusao.Name := 'ServicosDatasetinclusao';
    ServicosDatasetinclusao.FieldName := 'inclusao';
    ServicosDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ServicosDatasetalteracao.SetParentComponent(ServicosDataset);
    ServicosDatasetalteracao.Name := 'ServicosDatasetalteracao';
    ServicosDatasetalteracao.FieldName := 'alteracao';
    ServicosDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ServicosDatasetexclusao.SetParentComponent(ServicosDataset);
    ServicosDatasetexclusao.Name := 'ServicosDatasetexclusao';
    ServicosDatasetexclusao.FieldName := 'exclusao';
    ServicosDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ServicosDatasetid.SetParentComponent(ServicosDataset);
    ServicosDatasetid.Name := 'ServicosDatasetid';
    ServicosDatasetid.Tag := 1;
    ServicosDatasetid.FieldName := 'id';
    ServicosDatasetid.Required := True;
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := ServicosDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 255;
    tmrConsulta.Top := 224;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    btnExportarExcel.AfterLoadDFMValues;
    ServicosDataset.AfterLoadDFMValues;
    ServicosDatasetcodigo_interno.AfterLoadDFMValues;
    ServicosDatasetnome.AfterLoadDFMValues;
    ServicosDatasetunidadesigla.AfterLoadDFMValues;
    ServicosDatasetservico_preco.AfterLoadDFMValues;
    ServicosDatasetstatus_id.AfterLoadDFMValues;
    ServicosDatasetservico_garantia.AfterLoadDFMValues;
    ServicosDatasettipo_servico_codigo.AfterLoadDFMValues;
    ServicosDatasetnbsnbs.AfterLoadDFMValues;
    ServicosDatasetnbsdescricao.AfterLoadDFMValues;
    ServicosDatasetserv_nacionalcTribNac.AfterLoadDFMValues;
    ServicosDatasetserv_nacionaldescricao.AfterLoadDFMValues;
    ServicosDatasetcodigo_issqn.AfterLoadDFMValues;
    ServicosDatasetcodigo_tributacao_municipio.AfterLoadDFMValues;
    ServicosDatasetexcluido.AfterLoadDFMValues;
    ServicosDatasetinclusao.AfterLoadDFMValues;
    ServicosDatasetalteracao.AfterLoadDFMValues;
    ServicosDatasetexclusao.AfterLoadDFMValues;
    ServicosDatasetid.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
